import React from 'react';

// Other Information - Email. 36x36 gradient-bordered tile (the frame is part of
// the artwork), glyph exactly as Figma drew it. Gradient ids are per-instance
// (useId) so several icons on one page don't share ids and break.
const GRADIENT_STOPS = (
  <>
    <stop stopColor="#7458F6" />
    <stop offset="1" stopColor="#84AEF8" />
  </>
);

const EmailIcon = ({ size = 36 }) => {
  const uid = React.useId();
  const g = (n) => `email_${uid}_${n}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="0.5" y="0.5" width="35" height="35" rx="8.5" stroke={`url(#${g(0)})`} />
      <rect x="9" y="12" width="18" height="12" rx="1.5" stroke={`url(#${g(1)})`} />
      <path
        d="M9.5 13L18 19L26.5 13"
        stroke={`url(#${g(2)})`}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient id={g(0)} x1="18" y1="0" x2="18" y2="36" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(1)} x1="18" y1="11.5" x2="18" y2="24.5" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
        <linearGradient id={g(2)} x1="18" y1="13" x2="18" y2="19" gradientUnits="userSpaceOnUse">
          {GRADIENT_STOPS}
        </linearGradient>
      </defs>
    </svg>
  );
};

export default EmailIcon;
